import { Link } from "@inertiajs/react"

/**
 * Why an enquiry list is empty when the site is plainly getting enquiries.
 *
 * While the "Keep enquiries in the admin" switch is off, the public forms are
 * delivered to the inbox and nothing is written down — so this list has
 * nothing to show and never will for that period. Without the note, an empty
 * table reads as a broken form.
 */
export function EnquiryStorageNotice({ what }: { what: string }) {
  return (
    <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
      {what} are going straight to the inbox and are not being kept here. Turn on{" "}
      <Link href="/admin/features" className="underline">
        Keep enquiries in the admin
      </Link>{" "}
      to start storing them — earlier ones can't be recovered, because they were
      never written down.
    </div>
  )
}
